import React, { HtmlHTMLAttributes, PropsWithChildren, useState } from 'react'

import { cn } from '@/lib/utils'

import {
  Tooltip as BaseTooltip,
  TooltipContent,
  TooltipTrigger
} from '../ui/tooltip'

const Tooltip: React.FC<
  PropsWithChildren<{
    triggerProps: PropsWithChildren<HtmlHTMLAttributes<HTMLButtonElement>>
    contentProps?: React.ComponentProps<typeof TooltipContent>
  }>
> = ({ children, triggerProps, contentProps }) => {
  const [open, setState] = useState(false)
  return (
    <BaseTooltip open={open}>
      <TooltipTrigger asChild>
        <button
          {...triggerProps}
          onMouseEnter={() => {
            setState(true)
          }}
          onMouseLeave={() => {
            setState(false)
          }}
          onClick={() => {
            setState(true)
          }}
        />
      </TooltipTrigger>
      <TooltipContent
        {...contentProps}
        className={cn(
          'mx-3 max-w-[calc(100vw-24px)] xl:max-w-none',
          'rounded-md border bg-secondary p-2 text-xs leading-relaxed',
          contentProps?.className
        )}
      >
        {children}
      </TooltipContent>
    </BaseTooltip>
  )
}

export default Tooltip
